"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FUZZYSORT_MIN_THRESHOLD = void 0;
const FUZZYSORT_MIN_THRESHOLD = 0.3; // Don't use matches worse than this
exports.FUZZYSORT_MIN_THRESHOLD = FUZZYSORT_MIN_THRESHOLD;
//# sourceMappingURL=constants.js.map